function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from "react-bootstrap";
import AddAttendant from '../components/forms/AddAttendant';
import { Space, Divider, Descriptions, Tabs, List, Drawer, Button, Skeleton, notification, Modal, Input, Form, Alert } from "antd";
import { CalendarCheckFill, CashStack, DoorOpenFill, CalendarDateFill, EnvelopeCheckFill, PersonRolodex, Search, EyeFill, PersonCheckFill, PencilSquare, TrashFill, Dot, MegaphoneFill } from "react-bootstrap-icons";
import AddSubject from '../components/forms/AddSubject';
import Common from '../components/includes/Common';
import AddSession from '../components/forms/AddSession';
import EditSession from '../components/forms/EditSession';
import EditSubject from '../components/forms/EditSubject';
import SendSmsToList from '../components/forms/SendSmsToList';
import moment from "moment";
import InSession from '../components/InSession';
import AddExistingAttendantSession from '../components/forms/AddExistingAttenderSession';
import AddInstructor from '../components/forms/AddInstructor';
import InsctructorsList from '../components/InstructorsList';
import SendSingleSms from '../components/forms/SendSingleSms';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var confirm = Modal.confirm;
var Learning = function Learning() {
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    allSubjects = _useState2[0],
    setAllSubjects = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    upcomingSessions = _useState4[0],
    setUpcomingSessions = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    currentSessions = _useState6[0],
    setCurrentSessions = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedSubject = _useState8[0],
    setSelectedSubject = _useState8[1];
  var _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    selectedSession = _useState0[0],
    setSelectedSession = _useState0[1];
  var _useState1 = useState(null),
    _useState10 = _slicedToArray(_useState1, 2),
    selectedAttendant = _useState10[0],
    setSelectedAttendant = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isDataChanged = _useState12[0],
    setIsDataChanged = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isDataLoading = _useState14[0],
    setIsDataLoading = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    showEditSubject = _useState16[0],
    setShowEditSubject = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    showEditSession = _useState18[0],
    setShowEditSession = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    showNewSession = _useState20[0],
    setShowNewSession = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    showSendSms = _useState22[0],
    setShowSendSms = _useState22[1];
  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    showSendSmsList = _useState24[0],
    setShowSendSmsList = _useState24[1];
  var _useState25 = useState([]),
    _useState26 = _slicedToArray(_useState25, 2),
    monthlyTransactions = _useState26[0],
    setMonthlytransactions = _useState26[1];
  var _useState27 = useState([]),
    _useState28 = _slicedToArray(_useState27, 2),
    dailyTransactions = _useState28[0],
    setDailytransactions = _useState28[1];
  var _useState29 = useState(0),
    _useState30 = _slicedToArray(_useState29, 2),
    balance = _useState30[0],
    setBalance = _useState30[1];
  var _useState31 = useState(0),
    _useState32 = _slicedToArray(_useState31, 2),
    totalMonthly = _useState32[0],
    setTotalMonthly = _useState32[1];
  var _useState33 = useState(0),
    _useState34 = _slicedToArray(_useState33, 2),
    totalDaily = _useState34[0],
    setTotalDaily = _useState34[1];
  var _useState35 = useState([]),
    _useState36 = _slicedToArray(_useState35, 2),
    addedAttendance = _useState36[0],
    setAddedAttendance = _useState36[1];
  var _useState37 = useState(false),
    _useState38 = _slicedToArray(_useState37, 2),
    inSessionVisible = _useState38[0],
    setInSessionVisible = _useState38[1];
  var _useState39 = useState(false),
    _useState40 = _slicedToArray(_useState39, 2),
    isSearchProcessing = _useState40[0],
    setIsSearchProcessing = _useState40[1];
  var _useState41 = useState(''),
    _useState42 = _slicedToArray(_useState41, 2),
    searchError = _useState42[0],
    setSearchError = _useState42[1];
  var _useState43 = useState(null),
    _useState44 = _slicedToArray(_useState43, 2),
    foundedAttender = _useState44[0],
    setFoundAttender = _useState44[1];
  var _useState45 = useState(false),
    _useState46 = _slicedToArray(_useState45, 2),
    addUserSessionVisible = _useState46[0],
    setAddUserSessionVisible = _useState46[1];
  var _useState47 = useState([]),
    _useState48 = _slicedToArray(_useState47, 2),
    iList = _useState48[0],
    setIList = _useState48[1];
  var handleSessionDelete = function handleSessionDelete(session) {
    setSelectedSession(session);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["La suppression du la session ", session.label]
      }),
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + "deletelearningsession", {
          id: session.id.toString(),
          user_id: Common.currentUser.id
        }).then(function (response) {
          if (response.data.status == 200) {
            notification.success({
              message: "Ok!",
              description: "Opération réussie ..."
            });
          } else {
            setErrorMessage(response.data.message);
          }
        })["catch"](function (error) {
          setErrorMessage("Une erreur est survenue");
        })["finally"](function () {});
      }
    });
  };
  var handleSubjectDelete = function handleSubjectDelete(subject) {
    setSelectedSubject(subject);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["La suppression de la formation ", subject.label]
      }),
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + "deletesubject", {
          id: subject.id.toString(),
          user_id: Common.currentUser.id
        }).then(function (response) {
          if (response.data.status == 200) {
            notification.success({
              message: "Ok!",
              description: "Opération réussie ..."
            });
          } else {
            setErrorMessage(response.data.message);
          }
        })["catch"](function (error) {
          setErrorMessage("Une erreur est survenue");
        })["finally"](function () {});
      }
    });
  };
  var onSearchFinish = function onSearchFinish(values) {
    setIsSearchProcessing(true);
    setSearchError('');
    var fd = new FormData();
    fd.append("s_mobile", values.s_mobille);
    axios.get("".concat(Common.baseApiUrl, "getattenderbymobile/").concat(values.s_mobile, "/").concat(Common.currentUser.id)).then(function (response) {
      if (response.data.status == 200) {
        setFoundAttender(response.data.attender);
        setAddUserSessionVisible(true);
      } else {
        setSearchError(response.data.message);
      }
    })["catch"](function (error) {
      setSearchError("Une erreur est survenue");
    })["finally"](function () {
      setIsSearchProcessing(false);
    });
  };
  var items = [{
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(DoorOpenFill, {
        size: 23
      }), " ACCUEIL"]
    }),
    key: 1,
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 5,
            md: 5,
            children: /*#__PURE__*/_jsx("div", {
              style: {
                background: "#FFFFFF",
                padding: "10px",
                borderRadius: "4px"
              },
              children: /*#__PURE__*/_jsx(AddAttendant, {
                handler: function handler() {
                  setIsDataChanged(true);
                }
              })
            })
          }), /*#__PURE__*/_jsxs(Col, {
            lg: 7,
            md: 7,
            children: [/*#__PURE__*/_jsxs("div", {
              style: {
                background: "#FFDE59",
                padding: "10px",
                borderRadius: "4px"
              },
              children: [/*#__PURE__*/_jsxs(Space, {
                children: [/*#__PURE__*/_jsx(CashStack, {
                  size: 25
                }), /*#__PURE__*/_jsxs("h6", {
                  children: [/*#__PURE__*/_jsx("b", {
                    children: "SOLDE"
                  }), " : ", balance.toLocaleString("Fr"), " GNF"]
                })]
              }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs(Descriptions, {
                column: 2,
                children: [/*#__PURE__*/_jsxs(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "RECU AURJOURD'HUI"
                  }),
                  children: [" ", totalDaily.toLocaleString("Fr"), " GNF"]
                }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "RECU CE MOIS"
                  }),
                  children: [" ", totalMonthly.toLocaleString("Fr"), " GNF"]
                })]
              })]
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Form, {
              onFinish: onSearchFinish,
              layout: "vertical",
              children: [searchError.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
                children: /*#__PURE__*/_jsx(Alert, {
                  type: "error",
                  message: searchError,
                  banner: true
                })
              }), /*#__PURE__*/_jsxs(Space, {
                direction: "horizontal",
                children: [/*#__PURE__*/_jsx(Form.Item, {
                  name: "s_mobile",
                  rules: [{
                    required: true,
                    message: "Veuillez entrer un numéro mobile"
                  }],
                  children: /*#__PURE__*/_jsx(Input, {})
                }), /*#__PURE__*/_jsx(Form.Item, {
                  children: /*#__PURE__*/_jsx(Button, {
                    loading: isSearchProcessing,
                    htmlType: "submit",
                    type: "primary",
                    children: /*#__PURE__*/_jsx("b", {
                      children: /*#__PURE__*/_jsx(Search, {
                        size: 24
                      })
                    })
                  })
                })]
              })]
            }), /*#__PURE__*/_jsxs("div", {
              style: {
                background: "#FFFFFF",
                padding: "10px",
                borderRadius: "4px"
              },
              children: [/*#__PURE__*/_jsxs(Space, {
                children: [/*#__PURE__*/_jsx(CalendarCheckFill, {
                  size: 25
                }), /*#__PURE__*/_jsx("h6", {
                  children: /*#__PURE__*/_jsx("b", {
                    children: "COURS A VENIR"
                  })
                })]
              }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(List, {
                loading: isDataLoading,
                itemLayout: "horizontal",
                dataSource: upcomingSessions,
                renderItem: function renderItem(item) {
                  return /*#__PURE__*/_jsx(List.Item, {
                    actions: [/*#__PURE__*/_jsx("a", {
                      onClick: function onClick() {
                        setSelectedSession(item);
                        setShowSendSmsList(true);
                      },
                      children: /*#__PURE__*/_jsx(MegaphoneFill, {
                        size: 24
                      })
                    })],
                    children: /*#__PURE__*/_jsxs(Skeleton, {
                      avatar: true,
                      title: false,
                      loading: isDataLoading,
                      active: true,
                      children: [/*#__PURE__*/_jsx(List.Item.Meta, {
                        title: /*#__PURE__*/_jsx("b", {
                          children: item.label
                        }),
                        description: item.description
                      }), /*#__PURE__*/_jsx("div", {})]
                    })
                  });
                }
              })]
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("div", {
              style: {
                background: "#FFFFFF",
                padding: "10px",
                borderRadius: "4px"
              },
              children: [/*#__PURE__*/_jsxs(Space, {
                children: [/*#__PURE__*/_jsx(PersonCheckFill, {
                  size: 25
                }), /*#__PURE__*/_jsx("h6", {
                  children: /*#__PURE__*/_jsx("b", {
                    children: "INSCRIT(S) AJOURDH'UI"
                  })
                })]
              }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(List, {
                loading: isDataLoading,
                itemLayout: "horizontal",
                dataSource: addedAttendance,
                renderItem: function renderItem(item) {
                  return /*#__PURE__*/_jsx(List.Item, {
                    actions: [/*#__PURE__*/_jsx("a", {
                      onClick: function onClick() {
                        setSelectedAttendant(item.attendant);
                        setShowSendSms(true);
                      },
                      children: /*#__PURE__*/_jsx(MegaphoneFill, {
                        size: 24
                      })
                    })],
                    children: /*#__PURE__*/_jsxs(Skeleton, {
                      avatar: true,
                      title: false,
                      loading: isDataLoading,
                      active: true,
                      children: [/*#__PURE__*/_jsx(List.Item.Meta, {
                        title: /*#__PURE__*/_jsx("b", {
                          children: item.attendant.name
                        }),
                        description: item.bill != null && /*#__PURE__*/_jsxs("p", {
                          children: ["Pay\xE9 : ", item.bill.paid_amount.toLocaleString("Fr"), ", Reste \xE0 payer: ", (item.bill.total_amount - item.bill.paid_amount).toLocaleString("Fr")]
                        })
                      }), /*#__PURE__*/_jsx("div", {})]
                    })
                  });
                }
              })]
            })]
          })]
        })
      })
    })
  }, {
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(CalendarDateFill, {
        size: 23
      }), " PROGRAMME"]
    }),
    key: 2,
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 5,
            md: 5,
            children: /*#__PURE__*/_jsx("div", {
              style: {
                background: "#FFFFFF",
                padding: "12px",
                borderRadius: "6px"
              },
              children: /*#__PURE__*/_jsx(AddSubject, {
                handler: function handler() {
                  setIsDataChanged(true);
                }
              })
            })
          }), /*#__PURE__*/_jsxs(Col, {
            lg: 7,
            md: 7,
            children: [/*#__PURE__*/_jsxs("div", {
              style: {
                background: "#FFFFFF",
                padding: "12px",
                borderRadius: "6px"
              },
              children: [/*#__PURE__*/_jsxs(Space, {
                direction: "horizontal",
                children: [/*#__PURE__*/_jsx("h6", {
                  children: /*#__PURE__*/_jsx("b", {
                    children: "SESSIONS EN COURS"
                  })
                }), /*#__PURE__*/_jsx(Dot, {
                  style: {
                    color: "#59AC93"
                  },
                  size: 72
                })]
              }), /*#__PURE__*/_jsx(List, {
                loading: isDataLoading,
                itemLayout: "horizontal",
                dataSource: currentSessions,
                renderItem: function renderItem(item) {
                  return /*#__PURE__*/_jsx(List.Item, {
                    actions: [/*#__PURE__*/_jsx("a", {
                      onClick: function onClick() {
                        setSelectedSession(item);
                        setInSessionVisible(true);
                      },
                      children: /*#__PURE__*/_jsx(EyeFill, {
                        size: 20
                      })
                    }), /*#__PURE__*/_jsx("a", {
                      onClick: function onClick() {
                        setSelectedSession(item);
                        setShowSendSmsList(true);
                      },
                      children: /*#__PURE__*/_jsx(MegaphoneFill, {
                        size: 20
                      })
                    }), /*#__PURE__*/_jsx("a", {
                      onClick: function onClick() {
                        setSelectedSession(item);
                        setShowEditSession(true);
                      },
                      children: /*#__PURE__*/_jsx(PencilSquare, {
                        size: 20
                      })
                    }), /*#__PURE__*/_jsx("a", {
                      onClick: function onClick() {
                        handleSessionDelete(item);
                      },
                      children: /*#__PURE__*/_jsx(TrashFill, {
                        size: 24
                      })
                    })],
                    children: /*#__PURE__*/_jsxs(Skeleton, {
                      avatar: true,
                      title: false,
                      loading: isDataLoading,
                      active: true,
                      children: [/*#__PURE__*/_jsx(List.Item.Meta, {
                        title: /*#__PURE__*/_jsx("b", {
                          children: item.label
                        }),
                        description: item.attendants.length.toLocaleString("Fr") + " inscrit(s)"
                      }), /*#__PURE__*/_jsx("div", {})]
                    })
                  });
                }
              })]
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("div", {
              style: {
                background: "#FFFFFF",
                padding: "12px",
                borderRadius: "6px"
              },
              children: [/*#__PURE__*/_jsxs(Space, {
                direction: "horizontal",
                children: [/*#__PURE__*/_jsx("h6", {
                  children: /*#__PURE__*/_jsx("b", {
                    children: "SESSION(S) A VENIR"
                  })
                }), /*#__PURE__*/_jsx(Dot, {
                  style: {
                    color: "#AC724E"
                  },
                  size: 72
                })]
              }), /*#__PURE__*/_jsx(List, {
                loading: isDataLoading,
                itemLayout: "horizontal",
                dataSource: upcomingSessions,
                renderItem: function renderItem(item) {
                  return /*#__PURE__*/_jsx(List.Item, {
                    actions: [/*#__PURE__*/_jsx("a", {
                      onClick: function onClick() {
                        setSelectedSession(item);
                        setInSessionVisible(true);
                      },
                      children: /*#__PURE__*/_jsx(EyeFill, {
                        size: 20
                      })
                    }), /*#__PURE__*/_jsx("a", {
                      onClick: function onClick() {
                        setSelectedSession(item);
                        setShowSendSmsList(true);
                      },
                      children: /*#__PURE__*/_jsx(MegaphoneFill, {
                        size: 20
                      })
                    }), /*#__PURE__*/_jsx("a", {
                      onClick: function onClick() {
                        setSelectedSession(item);
                        setShowEditSession(true);
                      },
                      children: /*#__PURE__*/_jsx(PencilSquare, {
                        size: 20
                      })
                    }), /*#__PURE__*/_jsx("a", {
                      onClick: function onClick() {
                        handleSessionDelete(item);
                      },
                      children: /*#__PURE__*/_jsx(TrashFill, {
                        size: 20
                      })
                    })],
                    children: /*#__PURE__*/_jsxs(Skeleton, {
                      avatar: true,
                      title: false,
                      loading: isDataLoading,
                      active: true,
                      children: [/*#__PURE__*/_jsx(List.Item.Meta, {
                        title: /*#__PURE__*/_jsx("b", {
                          children: item.label
                        }),
                        description: item.attendants.length.toLocaleString("Fr") + " inscrit(s)"
                      }), /*#__PURE__*/_jsx("div", {})]
                    })
                  });
                }
              })]
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("div", {
              style: {
                background: "#FFFFFF",
                padding: "12px",
                borderRadius: "6px"
              },
              children: [/*#__PURE__*/_jsxs(Space, {
                direction: "horizontal",
                children: [/*#__PURE__*/_jsx("h6", {
                  children: /*#__PURE__*/_jsx("b", {
                    children: "TOUTES LES FORMATIONS"
                  })
                }), /*#__PURE__*/_jsx(Dot, {
                  style: {
                    color: "#9C928C"
                  },
                  size: 72
                })]
              }), /*#__PURE__*/_jsx(List, {
                loading: isDataLoading,
                itemLayout: "horizontal",
                dataSource: allSubjects,
                renderItem: function renderItem(item) {
                  return /*#__PURE__*/_jsx(List.Item, {
                    actions: [/*#__PURE__*/_jsx("a", {
                      onClick: function onClick() {
                        setSelectedSubject(item);
                        setShowEditSubject(item);
                      },
                      children: /*#__PURE__*/_jsx(PencilSquare, {
                        size: 24
                      })
                    }), /*#__PURE__*/_jsx("a", {
                      onClick: function onClick() {
                        handleSubjectDelete(item);
                      },
                      children: /*#__PURE__*/_jsx(TrashFill, {
                        size: 24
                      })
                    }), /*#__PURE__*/_jsx("a", {
                      onClick: function onClick() {
                        setSelectedSubject(item);
                        setShowNewSession(true);
                      },
                      children: /*#__PURE__*/_jsx("b", {
                        children: "CREER UN SESSION"
                      })
                    })],
                    children: /*#__PURE__*/_jsxs(Skeleton, {
                      avatar: true,
                      title: false,
                      loading: isDataLoading,
                      active: true,
                      children: [/*#__PURE__*/_jsx(List.Item.Meta, {
                        title: /*#__PURE__*/_jsx("b", {
                          children: item.label
                        }),
                        description: item.description
                      }), /*#__PURE__*/_jsx("div", {})]
                    })
                  });
                }
              })]
            })]
          })]
        })
      })
    })
  }, {
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(PersonRolodex, {
        size: 24
      }), " CONSULTANTS"]
    }),
    key: 3,
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsx(Col, {
            lg: 8,
            md: 7,
            children: /*#__PURE__*/_jsx(InsctructorsList, {
              list: iList,
              refresh: function refresh() {
                setIsDataChanged(true);
              }
            })
          })
        })
      })
    })
  }];
  useEffect(function () {
    setIsDataChanged(false);
    axios.all([axios.get(Common.baseApiUrl + "getallsubjects/" + Common.currentUser.id), axios.get(Common.baseApiUrl + "getupcomingsessions/" + Common.currentUser.id), axios.get(Common.baseApiUrl + "getcurrentsessions/" + Common.currentUser.id), axios.get(Common.baseApiUrl + "getcashbox/" + Common.currentUser.id), axios.get("".concat(Common.baseApiUrl, "getallcashtransactions/").concat(Common.currentUser.id, "/").concat(moment().startOf('day').format(), "/").concat(moment().endOf('day').format())), axios.get("".concat(Common.baseApiUrl, "getallcashtransactions/").concat(Common.currentUser.id, "/").concat(moment().startOf('month').format(), "/").concat(moment().endOf('month').format())), axios.get("".concat(Common.baseApiUrl, "getattendants/").concat(Common.currentUser.id, "/").concat(moment().startOf('day').format(), "/").concat(moment().endOf('day').format())), axios.get("".concat(Common.baseApiUrl, "getinstructors/").concat(Common.currentUser.id))]).then(function (response) {
      if (response[0].data.status == 200) {
        setAllSubjects(response[0].data.subjects);
      }
      if (response[1].data.status == 200) {
        setUpcomingSessions(response[1].data.sessions);
      }
      if (response[2].data.status == 200) {
        setCurrentSessions(response[2].data.sessions);
      }
      if (response[3].data.status == 200) {
        setBalance(response[3].data.cashBox.balance);
      }
      if (response[4].data.status == 200) {
        setTotalDaily(response[4].data.total_amount);
        setDailytransactions(response[4].data.transactions);
      }
      if (response[5].data.status == 200) {
        setTotalMonthly(response[5].data.total_amount);
        setMonthlytransactions(response[5].data.transactions);
      }
      if (response[6].data.status == 200) {
        setAddedAttendance(response[6].data.attendances);
      }
      if (response[7].data.status == 200) {
        setIList(response[7].data.instructors);
      }
    })["catch"](function (error) {
      notification.error({
        message: "Erreur!",
        description: "Une erreur est survenue pendant le chargement"
      });
    })["finally"](function () {});
  }, [isDataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Tabs, {
      items: items,
      animated: true
    }), selectedSession != null && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsx("b", {
          children: "MODIFIER LA SESSION"
        }),
        width: "400px",
        open: showEditSession,
        onCancel: function onCancel() {
          setShowEditSession(false);
        },
        destroyOnClose: true,
        footer: null,
        children: /*#__PURE__*/_jsx(EditSession, {
          session: selectedSession,
          handler: function handler() {
            setIsDataChanged(true);
            setShowEditSession(false);
            notification.success({
              message: "Ok!",
              description: "Opération réussie ..."
            });
          }
        })
      }), /*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsxs("b", {
          children: [/*#__PURE__*/_jsx(EnvelopeCheckFill, {
            size: 24
          }), " COMMUNIQUER AUX PATICIPANTS"]
        }),
        width: "400px",
        open: showSendSmsList,
        onCancel: function onCancel() {
          setShowSendSmsList(false);
        },
        destroyOnClose: true,
        footer: null,
        children: /*#__PURE__*/_jsx(SendSmsToList, {
          session: selectedSession,
          handler: function handler() {
            setIsDataChanged(true);
            setShowSendSmsList(false);
            notification.success({
              message: "Ok!",
              description: "L'envoie à été lancé avec succès"
            });
          }
        })
      }), /*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsxs("b", {
          children: [/*#__PURE__*/_jsx(PersonCheckFill, {
            size: 24
          }), " PARTICIPANTS"]
        }),
        width: "900px",
        open: inSessionVisible,
        onCancel: function onCancel() {
          setInSessionVisible(false);
        },
        destroyOnClose: true,
        footer: null,
        children: /*#__PURE__*/_jsx(InSession, {
          session: selectedSession,
          handler: function handler() {
            setIsDataChanged(true);
            notification.success({
              message: "Ok!",
              description: "Opération réussie ..."
            });
          }
        })
      })]
    }), selectedSubject != null && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsx("b", {
          children: "NOUVELLE SESSION"
        }),
        width: "400px",
        open: showNewSession,
        onCancel: function onCancel() {
          setShowNewSession(false);
        },
        destroyOnClose: true,
        footer: null,
        children: /*#__PURE__*/_jsx(AddSession, {
          subject: selectedSubject,
          handler: function handler() {
            setShowNewSession(false);
            setIsDataChanged(true);
            notification.success({
              message: "Ok!",
              description: "Opération réussie ..."
            });
          }
        })
      }), /*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsx("b", {
          children: "MODIFIER LA FORMATION"
        }),
        width: "400px",
        open: showEditSubject,
        onCancel: function onCancel() {
          setShowEditSubject(false);
        },
        destroyOnClose: true,
        footer: null,
        children: /*#__PURE__*/_jsx(EditSubject, {
          subject: selectedSubject,
          handler: function handler() {
            setIsDataChanged(true);
            setShowEditSubject(false);
            notification.success({
              message: "Ok!",
              description: "Opération réussie ..."
            });
          }
        })
      })]
    }), foundedAttender != null && /*#__PURE__*/_jsx(Drawer, {
      title: /*#__PURE__*/_jsx("b", {
        children: "NOUVELLE SESSION"
      }),
      width: "320px",
      open: addUserSessionVisible,
      onClose: function onClose() {
        setAddUserSessionVisible(false);
      },
      destroyOnClose: true,
      children: /*#__PURE__*/_jsx(AddExistingAttendantSession, {
        attender: foundedAttender
      })
    }), selectedAttendant != null && /*#__PURE__*/_jsx(Modal, {
      title: /*#__PURE__*/_jsxs("b", {
        children: [/*#__PURE__*/_jsx(EnvelopeCheckFill, {
          size: 24
        }), " COMMUNIQUER AU PATICIPANT"]
      }),
      width: "400px",
      open: showSendSms,
      onCancel: function onCancel() {
        setShowSendSms(false);
      },
      destroyOnClose: true,
      footer: null,
      children: /*#__PURE__*/_jsx(SendSingleSms, {
        mobile: selectedAttendant.mobile,
        handler: function handler() {
          setIsDataChanged(true);
          setShowSendSms(false);
          notification.success({
            message: "Ok!",
            description: "Message envoyé !"
          });
        }
      })
    })]
  });
};
export default Learning;